import {
  MAX_IMAGE_SIZE,
  MAX_VIDEO_SIZE,
  MAX_DOCUMENT_SIZE,
  MAX_AUDIO_SIZE,
  ALLOWED_IMAGE_TYPES,
  ALLOWED_VIDEO_TYPES,
  ALLOWED_DOCUMENT_TYPES,
  ALLOWED_AUDIO_MIME_TYPES,
  MAX_DOCUMENT_SIZE_LABEL
} from '../constants/uploads'


export function validateFile(file: File, type: 'image' | 'video' | 'document' | 'audio'): string | null {
  let maxSize = 0;
  let allowedTypes: string[] = [];
  let typeLabel = '';

  switch (type) {
    case 'image':
      maxSize = MAX_IMAGE_SIZE;
      allowedTypes = ALLOWED_IMAGE_TYPES;
      typeLabel = 'image content';
      break;
    case 'video':
      maxSize = MAX_VIDEO_SIZE;
      allowedTypes = ALLOWED_VIDEO_TYPES;
      typeLabel = 'video content';
      break;
    case 'document':
      maxSize = MAX_DOCUMENT_SIZE;
      allowedTypes = ALLOWED_DOCUMENT_TYPES;
      typeLabel = 'document content';
      break;
    case 'audio':
      maxSize = MAX_AUDIO_SIZE;
      allowedTypes = Array.from(ALLOWED_AUDIO_MIME_TYPES);
      typeLabel = 'audio content';
      break;
  }

  if (!allowedTypes.includes(file.type)) {
    return `Invalid file type. Supported types: ${allowedTypes.join(', ')}`;
  }

  if (file.size > maxSize) {
    const sizeInMB = maxSize / (1024 * 1024);
    return `File exceeds the maximum allowed size of ${sizeInMB}MB for ${typeLabel}.`;
  }

  return null;
}

export function validatePdfFile(file: File): string | null {
  if (file.type !== 'application/pdf') {
    return 'Please upload PDF files only.'
  }
  if (file.size > MAX_DOCUMENT_SIZE) {
    return `File size must be less than ${MAX_DOCUMENT_SIZE_LABEL}.`
  }
  return null
}

export function getFileNameFromPath(path?: string | null): string | null {
  if (!path) return null
  const parts = path.split('/')
  return parts.length ? parts[parts.length - 1] : path
}


export function formatAudioTime(seconds: number): string {
  const mins = Math.floor(seconds / 60)
  const secs = Math.floor(seconds % 60)
  return `${mins}:${secs.toString().padStart(2, '0')}`
}
